module.exports = "./img/63ca326c68bf4922f05786c57d8eeef6.jpg";